export default __webpack_public_path__ + "static/media/curve-top.0b5351d3.svg";